<template>
    <div class="multi-year-selection" :class="getHiddenXs()" v-if="yearRanges">
        <select
            class="survey-year-range"
            v-model="selectedYearRange"
            v-on:change="yearRangeSelected"
            :disabled="!isEnabled"
            aria-label="Methodology"
        >
            <option value="0">Select Methodology</option>
            <option
                v-for="range in allYearRanges"
                v-bind:value="range.value"
                v-bind:key="range.value"
            >
                {{ range.display }}
            </option>
        </select>
        <div
            :class="'selection-box ' + (isEnabled ? '' : 'hidden-xs disabled')"
        >
            <div
                v-for="(year, itemIndex) in yearRanges[selectedYearRange]"
                v-bind:key="year.year"
                class="checkbox"
            >
                <label>
                    <input
                        type="checkbox"
                        v-model="selectedYears"
                        v-bind:value="year.year"
                        v-on:keydown="
                            common.navigateCheckboxes(
                                $event,
                                $refs.items,
                                itemIndex
                            )
                        "
                        ref="items"
                        :disabled="!isEnabled"
                        v-on:change="yearSelected"
                        :tabindex="itemIndex === 0 ? 0 : -1"
                    />{{ year.year }}
                    <!--:ref="'year' + yearIndex"-->
                    <!--v-on:keyup="keyHandler($event, yearIndex)" v-on:keypress="keyHandler($event, yearIndex)"-->
                </label>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';
import store from '@/store';

export default {
    /*model: {
      isEnabled: 'true'
    },*/
    props: ['isEnabled'],
    watch: /*no deep*/ {
        isEnabled(val) {
            if (val) {
                //this.selectedYearRange = 2;
            } else this.selectedYearRange = 0;
        }
    },
    created: function () {
        const vm = this;
        const allYears = store.state.dataLists.allYears;
        var descendingYears = allYears.slice().sort(function (a, b) {
            return b.year - a.year;
        });
        vm.allYearRanges = [
            { value: 2, display: '2011-' + descendingYears[0].year },
            { value: 1, display: '2004-2010' }
        ];
        vm.selectedYearRange = getSelectedYearRange(vm.isEnabled);
        vm.yearRanges = [
            [],
            descendingYears.filter((y) => y.year <= 2010),
            descendingYears.filter((y) => y.year >= 2011)
        ];
        vm.selectedYears = store.state.selModel.years.values;
    },
    data: function () {
        return {
            isActive: true,
            selectedYearRange: null,
            allYearRanges: [],
            yearRanges: null,
            common,
            selectedYears: []
        };
    },
    methods: {
        //keyHandler: function (e, itemIndex) {
        //  var vm = this;
        //  var nextIndex = 0;
        //  if (e.type === 'keydown') {
        //    if (e.code === 'ArrowRight' || e.code === 'ArrowDown') {
        //      nextIndex = ++itemIndex;
        //      if (nextIndex >= vm.$refs.items.length)
        //        nextIndex = 0;
        //      this.$refs.items[nextIndex].focus();
        //      e.preventDefault();
        //    }
        //    if (e.code === 'ArrowLeft' || e.code === 'ArrowUp') {
        //      nextIndex = --itemIndex;
        //      if (nextIndex < 0)
        //        nextIndex = vm.$refs.items.length - 1;
        //      this.$refs.items[nextIndex].focus();
        //      e.preventDefault();
        //    }
        //  }
        //},
        getHiddenXs: function () {
            return this.isEnabled ? '' : 'hidden-xs';
        },
        yearRangeSelected,
        yearSelected
    }
};

function yearRangeSelected() {
    const vm = this;
    vm.selectedYears = [];
    store.dispatch('selModel/setYears', { selectedYears: [] });
}

function yearSelected() {
    const vm = this;
    vm.selectedYears.sort(function (a, b) {
        return a - b;
    });
    store.dispatch('selModel/setYears', {
        selectedYears: vm.selectedYears
    });
}

function getSelectedYearRange(isEnabled) {
    const selectedYears = store.state.selModel.years.values;
    if (!isEnabled || selectedYears.length === 0) return 0;
    return selectedYears[0] <= 2010 ? 1 : 2;
}
</script>

<style scoped>
@media only screen and (min-width: 992px) {
    .multi-year-selection {
        margin-left: 13%;
    }
}
.selection-box {
    padding: 0 19px 0 19px;
    box-sizing: border-box;
    height: 230px;
    width: 190px;
    overflow-y: auto;
    margin-bottom: 20px;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.disabled {
    background-color: #f5f5f5;
}

.survey-year-range {
    width: 190px;
}
</style>
